import { ClickEvent, DataSourceExecutionEvent } from "@mcleod/components";
import { AutogenLayoutPayeeQuickInfo } from "./autogen/AutogenLayoutPayeeQuickInfo";
import { DrsPayee } from "../../settlement/src/DrsPayee";

export class PayeeQuickInfo extends AutogenLayoutPayeeQuickInfo {

    async sourceDriverAfterExecution(event: DataSourceExecutionEvent) {
        if (this.sourceAllPayees.activeRow?.get("contact.mobile_phone")) {
            this.textboxContactmobilePhone.visible = true;
        } else {
            this.textboxContactphone.visible = true;
        }
    }

}
